import { createSlice } from '@reduxjs/toolkit';
import { radioButtonPrenotazioneStepper } from '../../const/RadioButton/RadioButtonListRadio';

const getInitialDefaults = () => {
    const now = new Date();
    const tomorrow = new Date(new Date().setDate(now.getDate() + 1));

    const nineAM = new Date(new Date(tomorrow).setHours(9, 0, 0, 0));

    const defaultStartTime = now <= nineAM
        ? nineAM.toString()
        : new Date(new Date(tomorrow).setHours(now.getHours() + 1, 0, 0, 0)).toString();

    const defaultEndTime = new Date(new Date(tomorrow).setHours(18, 0, 0, 0)).toString();

    return {
        defaultDate: tomorrow.toString(),
        defaultStartTime,
        defaultEndTime,
        ripetizioneDataFine: new Date(new Date().setDate(now.getDate() + 1)).toString()
    };
};

const defaults = getInitialDefaults();

const initialState = {
    isPrenotaNewOpen: false,
    selectedDate: defaults.defaultDate, 
    selectedStartTime: defaults.defaultStartTime,
    selectedEndTime: defaults.defaultEndTime,
    selectedEdificio: null,
    selectedZona: null,
    selectedStanza: null,
    currentStep: 0, 
    utentePrenotazione: [],
    ripetizioneStatus: false,
    ripetizioneGiorni: [],
    ripetizioneDataFine: defaults.ripetizioneDataFine,
    radioButtonPrenotazionePerAltri: radioButtonPrenotazioneStepper[0].value,
    requestVersion: 0
};

const prenotazioneNewSlice = createSlice({
    name: 'prenotazioneNew',
    initialState,
    reducers: {
         openPrenotaNewDialog: (state) => { 
            const freshDefaults = getInitialDefaults();
            return {
                ...state, 
                isPrenotaNewOpen: true, 
                currentStep: 0,
                selectedDate: freshDefaults.defaultDate,
                selectedStartTime: freshDefaults.defaultStartTime,
                selectedEndTime: freshDefaults.defaultEndTime,
                ripetizioneDataFine: freshDefaults.ripetizioneDataFine
            };
         },
         closePrenotaNewDialog: (state) => {
            const freshDefaults = getInitialDefaults();
            return {
                ...initialState,
                isPrenotaNewOpen: false,
                currentStep: 0,
                selectedDate: freshDefaults.defaultDate,
                selectedStartTime: freshDefaults.defaultStartTime,
                selectedEndTime: freshDefaults.defaultEndTime,
                ripetizioneDataFine: freshDefaults.ripetizioneDataFine,
                selectedEdificio: null,
                selectedZona: null,
                selectedStanza: null,
                utentePrenotazione: [],
                ripetizioneStatus: false,
                ripetizioneGiorni: [],
                radioButtonPrenotazionePerAltri: radioButtonPrenotazioneStepper[0].value,
            };
         },
         setPrenotaNewDate: (state, action) => {
             return {...state, selectedDate: action.payload.date, selectedStartTime: action.payload.startTime, selectedEndTime: action.payload.endTime};
         },
         setPrenotaNewStep: (state, action) => {
             return {...state, currentStep: action.payload};
         },
         setPrenotaNewEdificioEZona: (state, action) => {
             return {...state, selectedEdificio: action.payload.edificio, selectedZona: action.payload.zona, currentStep: 1};
         },
         setPrenotaNewStanza: (state, action) => {
            return {...state, selectedStanza: action.payload, currentStep: 2};
        },
        setUtentePrenotazioneNew: (state, action) => {
            state.utentePrenotazione = action.payload;
        },
        setRipetizioneStatusNew: (state, action) => {
            state.ripetizioneStatus = action.payload;
        },
        setRipetizioneGiorniNew: (state, action) => {
            state.ripetizioneGiorni = action.payload;
        },
        setRipetizioneDataFineNew: (state, action) => {
            state.ripetizioneDataFine = action.payload;
        },
        setRadioButtonPrenotazionePerAltriNew: (state, action) => {
             state.radioButtonPrenotazionePerAltri = action.payload;
        },
        resetRipetizione: (state) => {
            state.ripetizioneStatus = false;
            state.ripetizioneGiorni = [];
            state.ripetizioneDataFine = defaults.ripetizioneDataFine;
        },
        incrementRequestVersion(state) {
            state.requestVersion += 1;
        }
    }
});

export const { 
    openPrenotaNewDialog, 
    closePrenotaNewDialog, 
    setPrenotaNewDate, 
    setPrenotaNewStep, 
    setPrenotaNewEdificioEZona, 
    setPrenotaNewStanza,
    setUtentePrenotazioneNew,
    setRipetizioneStatusNew,
    setRipetizioneGiorniNew,
    setRipetizioneDataFineNew,
    setRadioButtonPrenotazionePerAltriNew,
    resetRipetizione,
    incrementRequestVersion
} = prenotazioneNewSlice.actions;

const { reducer } = prenotazioneNewSlice;

export default reducer;
